import React from "react";

import { collection, getDocs, getFirestore, orderBy, query } from "firebase/firestore";

import app from "../firebase";

import { getStorage } from "firebase/storage";
import { Dev } from "../util/consoleUtil";
import firebaseError from "../util/firebaseError";

const db = getFirestore(app);
const storage = getStorage(app);

export const FileService = {
  List: () => {
    const [isLoading, setLoading] = React.useState(false);

    const [items, setItems] = React.useState<any[] | null>([]);

    const runRequest = async () => {
      return new Promise(async (Ok, Rej) => {
        try {
          setLoading(true);

          const mainRef = collection(db, "files");
          const queryRef = query(mainRef, orderBy("createdAtTimestamp", "desc"));
          const mainSnap = await getDocs(queryRef);
          const listData = [] as any;

          mainSnap.forEach((doc) => {
            listData.push({ id: doc.id, ...doc.data() });
          });

          setItems(listData);

          setLoading(false);
          Ok(listData);
        } catch (error) {
          console.log(...new Dev("Request Error [list]", error).Error());
          setLoading(false);
          Rej(new Error("Erro ao obter dados. " + firebaseError(error)));
        }
      });
    };

    return { items, isLoading, runRequest };
  },
};
